<template>
    <ThePage class="container">
        <card-profile
            ref="card_profile"
            class="mb-4"
            :pending="pending.profile"
            :company="company"
            @update="updateProfile" />

        <card-crt
            v-if="hasCrt"
            ref="card_crt"
            class="mb-4"
            :pending="pending.crt"
            :company="company"
            @update="updateCrt"
            @cancel="updateCrt({ inn: null })"
            @enable="enableCrt"
            @disable="disableCrt" />

        <card-fare
            ref="card_fare"
            class="mb-4"
            :fares="fares"
            :pending="pending.crt"
            :company="company"
            @apply="applyFare" />

        <card-billing
            :transactions="transactions"
            :currency="company.balance_currency" />

        <router-view />
    </ThePage>
</template>

<script>
import store from '@/store'
import ThePage from '@/components/ThePage'
import CardProfile from '@/components/profile/CardProfile'
import CardCrt from '@/components/profile/CardCrt'
import CardFare from '@/components/profile/CardFare'
import CardBilling from '@/components/profile/CardBilling'

export default {
    components: {
        ThePage,
        CardProfile,
        CardCrt,
        CardFare,
        CardBilling
    },

    data() {
        return {
            pending: {
                profile: false,
                crt: false,
                fare: false
            }
        }
    },

    computed: {
        company() {
            return store.state.company.profile.data
        },

        transactions() {
            return this.$store.state.company.billing.transactions
        },

        fares() {
            return this.$store.state.company.billing.fares.data
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        }
    },

    methods: {
        async updateProfile(attributes) {
            this.pending.profile = true

            const done = await this.$store.dispatch('company/profile/save', attributes)

            if (!done) {
                this.$refs.card_profile.mixinApiErrors(this.$store.state.company.profile.error)
            }

            this.pending.profile = false
        },

        async updateCrt(attributes) {
            this.pending.crt = true

            const done = await this.$store.dispatch('company/profile/save', attributes)

            if (!done) {
                this.$refs.card_crt.mixinApiErrors(this.$store.state.company.profile.error)
            }

            this.pending.crt = false
        },

        async enableCrt(attributes) {
            this.pending.crt = true

            const done = await this.$store.dispatch('company/profile/enableCrt', attributes)

            if (!done) {
                this.$refs.card_crt.mixinApiErrors(this.$store.state.company.profile.error)
            }

            this.pending.crt = false
        },

        async disableCrt() {
            this.pending.crt = true
            await this.$store.dispatch('company/profile/disableCrt')
            this.pending.crt = false
        },

        async applyFare(fareId) {
            this.pending.fare = true
            await this.$store.dispatch('company/billing/applyFare', fareId)
            this.pending.fare = false
        }
    },

    async beforeRouteEnter(to, from, next) {
        await Promise.all([
            store.dispatch('company/profile/fetch'),
            store.dispatch('company/billing/fetchTransactions'),
            store.dispatch('company/billing/fares/fetchAll')
        ])

        next()
    }
}
</script>
